import { useDocuments } from '../documents/DocumentStore'
import { FileDocument } from '../documents/FileDocument'
import { useProjectActiveFile } from '../project'

export function useActiveDocument() {
  const documents = useDocuments()
  const activeFile = useProjectActiveFile()
  return activeFile
    ? (documents.find(
        (document) => document instanceof FileDocument && document.path === activeFile?.path
      ) as FileDocument)
    : undefined
}
